import { getNullableField as e } from "../../../../common/utils/getNullableField.js";
import i from "../../../../node_modules/lodash-es/pick.js";
const n = (n2) => {
  var _a, _b, _c;
  const t = e(n2);
  return { ...i(n2, ["id", "equipmentModel", "factoryNumber", "power", "amount", "efficiency", "hourlyCost", "heatingArea", "maintenanceEndDate", "isReserve", "serviceOrganization"]), equipmentGroupId: t("equipmentGroup.id"), equipmentType: t("equipmentType"), equipmentManufacturer: { id: n2.equipmentManufacturer.id, name: n2.equipmentManufacturer.value }, serviceOrganizationId: t("serviceOrganization.id"), gasMeteringNodes: ((_a = n2.gasMeteringNodes) == null ? void 0 : _a.map((e2) => ({ id: e2.id, name: e2.name }))) || [], equipmentGroup: { id: (_b = n2.equipmentGroup) == null ? void 0 : _b.id, name: (_c = n2.equipmentGroup) == null ? void 0 : _c.value } };
};
export {
  n as convertInitialValues
};
//# sourceMappingURL=convertInitialValues.js.map
